<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body">
                <div class="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1 filter-box">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1 position-relative moubox">
                      <label>Mou</label>
                      <ng-select
                      [items]="mou_list"
                      bindLabel="name"
                      bindValue="_id"
                      [closeOnSelect]="false"
                      placeholder="Select mou"
                      [(ngModel)]="selected_filtermou"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getFilterMouId($event)"
                      >
                      </ng-select>
                    </div>
                    <div class="col-flex-2 mb-1 position-relative relbox">
                      <label>Relationship</label>
                      <ng-select
                      [items]="relationship_list"
                      bindLabel="name"
                      bindValue="_id"
                      [closeOnSelect]="false"
                      placeholder="Select relationship"
                      [(ngModel)]="selected_filter_relationship"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getFilterRelationshipId($event)"
                      >
                      </ng-select>
                    </div>
                    <div class="col-flex-2 mb-1 position-relative relbox">
                      <label>City</label>
                      <ng-select [items]="city_list" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false" placeholder="Select City"
                        [(ngModel)]="selected_filter_city" [ngModelOptions]="{ standalone: true }" (change)="getFilterCityId($event)">
                      </ng-select>
                    </div>
                    <div class="col-flex-2 mb-1 position-relative sortbybox">
                      <label>Sort By</label>
                      <ng-select
                      [items]="sortby_list"
                      bindLabel="name"
                      bindValue="_id"
                      [closeOnSelect]="false"
                      placeholder="Select mou"
                      [(ngModel)]="selected_sortby"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getSortbyId($event)"
                      >
                      </ng-select>
                    </div>
                  </div>
                </div>
                
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1 position-relative">
                      <input id="ngx-filter-ref"
                      class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                      type="text" (keydown.enter)="filter(searchVal)" placeholder="Search" #name
                      [(ngModel)]="searchVal" />
                      <button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                         placement="top" ngbTooltip="Add New" (click)="openModal(modalAdd,'','')">
                        +
                      </button>
                    </div>
                  </div>
                </div>
                <ngx-datatable class="bootstrap core-bootstrap mt-1" [columnMode]="ColumnMode.force" [headerHeight]="40"
                    [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                    [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
                <div class="col-12 mt-1">
                  <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">College Guideline</button>
                  
                </div>
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Name" prop="name" [width]="50">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="display_flex">
                    <div class="d-flex align-items-center">
                      <div class="avatar mr-1 ml-0 bg-primary">
                        <div class="avatar-content">
                          {{ row?.business_id[0]?.name | shortName }}
                        </div>
                      </div>
                       <!-- --------- card ------------------------------------ -->
                       <div class="card-overlay-on-hover">
                        <div class="card">
                          <div class="card-content">
                            <div class="card-img">
                              <div  class="avatarImg mr-1 ml-0">
                                <div class="avatar-contentImg">{{ row?.business_id[0]?.name | shortName }}</div>
                              </div>
                            </div>
                            <div class="card-body p-0">
                              <h5>{{row?.business_id[0]?.address}}</h5>
                              <p id="p-tag">{{row?.business_id[0]?.facebook_url}}</p>
                              <p id="p-tag">{{row?.business_id[0]?.linked_url}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- ---------------------------------------------------------- -->
                    </div>
                    <div class="cell-line-height cursor-pointer">
                    <p class="font-medium-1 line-height-1 mb-0" >
                      {{ row?.business_id[0]?.name }}
                    </p>
                  </div>
                    </div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Last Visited" prop="last_visited" [width]="10">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  {{ row?.last_visited | date :'longDate' }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Mou" prop="mou" [width]="10">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  {{ row?.mou }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="City" prop="city" [width]="20">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <span *ngFor="let item of row?.city" class="badge badge-pill bg-light-primary cursor-pointer" (click)="openModelCityUpdate(modalCityUpdate,row)">
                    {{ item.displayname }}
                  </span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Relationship" prop="relationship" [width]="20">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <!-- {{ row?.relationship }} -->
                  <p [matMenuTriggerFor]="relationship">
                    <span *ngIf="row?.relationship == 'normal'"
                    [ngClass]="{'bg-light-success badge badge-pill':row?.relationship == 'normal'}">
                    {{row?.relationship}}
                  </span>
                  <span *ngIf="row?.relationship == 'good'"
                    [ngClass]="{'bg-light-warning badge badge-pill':row?.relationship == 'good'}">
                    {{row?.relationship}}
                  </span>
                  <span *ngIf="row?.relationship == 'not_good'"
                    [ngClass]="{'bg-light-danger badge badge-pill':row?.relationship == 'not_good'}">
                    {{row?.relationship}}
                  </span>
                  <span *ngIf="row?.relationship == 'unknown'"
                  [ngClass]="{'bg-light-danger badge badge-pill':row?.relationship == 'unknown'}">
                  {{row?.relationship}}
                </span>

                <span *ngIf="row?.relationship == 'interested'" [ngClass]="{'bg-light-warning badge badge-pill':row?.relationship == 'interested'}">
                  {{row?.relationship}}
                </span>
                <span *ngIf="row?.relationship == 'not_interested'"
                  [ngClass]="{'bg-light-danger badge badge-pill':row?.relationship == 'not_interested'}">
                  {{row?.relationship}}
                </span>
                <span *ngIf="row?.relationship == 'blacklisted'"
                  [ngClass]="{'bg-light-danger badge badge-pill':row?.relationship == 'blacklisted'}">
                  {{row?.relationship}}
                </span>
                 
                  </p>
                  <mat-menu #relationship="matMenu">
                    <div *ngFor="let relation of relationship_list">
                      <button mat-menu-item *ngIf="relation?._id !==row?.relationship"
                      (click)="updateRelation(row._id,relation._id)">
                      <span>
                        <span [ngClass]="{'bg-light-success badge badge-pill':relation._id == 'normal'}"
                        placement="top" *ngIf="relation._id == 'normal'">{{relation.name}}</span>
                        <span [ngClass]="{'bg-light-warning badge badge-pill':relation._id == 'good'}"
                        placement="top" *ngIf="relation._id == 'good'">{{relation.name}}</span>
                        <span [ngClass]="{'bg-light-danger badge badge-pill':relation._id == 'not_good'}"
                        placement="top"
                        *ngIf="relation._id == 'not_good'">{{relation.name}}</span>
                        <span [ngClass]="{'bg-light-danger badge badge-pill':relation._id == 'unknown'}"
                        placement="top"
                        *ngIf="relation._id == 'unknown'">{{relation.name}}</span>

                        <span *ngIf="relation._id == 'interested'"
                          [ngClass]="{'bg-light-warning badge badge-pill':relation._id == 'interested'}">
                          {{relation.name}}
                        </span>
                        <span *ngIf="relation._id == 'not_interested'"
                          [ngClass]="{'bg-light-danger badge badge-pill':relation._id == 'not_interested'}">
                          {{relation.name}}
                        </span>
                        <span *ngIf="relation._id == 'blacklisted'"
                          [ngClass]="{'bg-light-danger badge badge-pill':relation._id == 'blacklisted'}">
                          {{relation.name}}
                        </span>
                      </span>
                      </button>
                    </div>
                  </mat-menu>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Email" prop="email" [width]="20">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div *ngIf="row?.business_id[0]?.email">
                    <p id="email-p">{{ row?.business_id[0]?.email }}</p>
                  </div>
                  <div *ngIf="!row?.business_id[0]?.email">-</div>

                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Phone" prop="phone" [width]="20">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div *ngIf="row?.business_id[0]?.phone">
                    {{ row?.business_id[0]?.phone }}
                  </div>
                  <div *ngIf="!row?.business_id[0]?.phone">-</div>
                </ng-template>
              </ngx-datatable-column>
              <!-- <ngx-datatable-column name="Type" prop="type" [width]="10">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div *ngIf="row?.business_type?.displayname">
                    {{ row?.business_type?.displayname }}
                  </div>
                  <div *ngIf="!row?.business_type?.displayname">-</div>
                </ng-template>
              </ngx-datatable-column> -->
              <ngx-datatable-column name="Actions"  width="10"
                *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i mat-button [matMenuTriggerFor]="menu"
                    class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                  
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item
                      (click)="openModal(modalAdd,row?._id,row)">Edit</button>
                      <button mat-menu-item
                      (click)="goToEdit(row)">Business Edit</button>
                      <button mat-menu-item (click)="copyItem(row?._id)">Copy Detail Link</button>
                      <button  mat-menu-item (click)="addContact(row?.business_id[0]?._id)">Add Contact</button>
                      <button  mat-menu-item (click)="openContactModal(myModalContact,row)">View Contact</button>
                      <button *ngIf="user_role.roles =='admin'" mat-menu-item (click)="ConfirmColor(row._id)">Delete</button>
                      <button mat-menu-item (click)="openModalTagsUpdate(modalTgasUpdate,row)">Update Training Tags</button>
                      <button mat-menu-item (click)="openModalEvent(myModalEvent,row)">Events
                        <!-- <i class="ft-aperture text-primary cursor-pointer mx-1" placement="bottom" ngbTooltip="Events" ></i> -->
                      </button>
                      <button mat-menu-item (click)="openModalPlacement(myModalPlacement,row)">Placements
                  <!-- <i class="ft-codepen text-primary cursor-pointer mx-1" placement="bottom" ngbTooltip="Placements" ></i> -->

                      </button>
                    </mat-menu>
                  <!-- <i class="ft-edit text-primary cursor-pointer mr-2" [routerLink]="['/business/edit', row._id]"
                    (click)="editBusiness(row._id)"></i>
                  <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                    (click)="ConfirmColor(row._id)"></i> -->
                </ng-template>
              </ngx-datatable-column>
              <!-- <ngx-datatable-column name="Business" prop="business_id" [width]="70">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <p class="d-flex" *ngFor="let type of row?.type; let isLast = last">
                    <span>
                      {{type?.displayname}}
                      <span *ngIf=" !isLast">,</span>
                    </span>
                  </p>
                </ng-template>
              </ngx-datatable-column> -->

            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

<!-----  Contacts list popup --------------------->
<div>
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Contacts for {{row_name}}</h4>

      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ngx-datatable [rows]="contact_data" [rowHeight]="50" class="bootstrap core-bootstrap" [limit]="10"
        [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
        <ngx-datatable-column name="Name" prop="name" [width]="50">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <div class="d-flex align-items-center">
              {{row?.name}}
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Email" prop="email" [width]="30">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            {{row?.email }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Phone" prop="phone" [width]="10">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <span>{{row?.phone}}</span>
          </ng-template>
        </ngx-datatable-column>
    
      </ngx-datatable>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
    </div>
  </ng-template>
</div>

<!---------- Add New College Popup ------------------------ -->
<div>
  <ng-template #modalAdd let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="!row_id">Add New</h4>
      <h4 class="modal-title" *ngIf="row_id">Update</h4>

      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Business</label>
        <ng-select
        [items]="business_list"
        bindLabel="name"
        bindValue="_id"
        [closeOnSelect]="false"
        placeholder="Select business"
        [multiple]="true"
        [(ngModel)]="selected_business"
        [ngModelOptions]="{ standalone: true }"
        (change)="getBusinessId($event)"
        >
        </ng-select>
      </div>
      <div class="form-group">
        <label>City</label>
        <ng-select [items]="city_list" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
          placeholder="Select City" [multiple]="true" [(ngModel)]="selected_city"
          [ngModelOptions]="{ standalone: true }" (change)="getCityId($event)">
        </ng-select>
      </div>
      <div class="form-group">
        <label>Mou</label>
        <ng-select
        [items]="mou_list"
        bindLabel="name"
        bindValue="_id"
        [closeOnSelect]="false"
        placeholder="Select mou"
        [(ngModel)]="selected_mou"
        [ngModelOptions]="{ standalone: true }"
        (change)="getMouId($event)"
        >
        </ng-select>
      </div>
      <div class="form-group">
        <label>Last Visited</label>
        <input type="date" [(ngModel)]="model.last_visited" class="form-control" name="last_visited" id="last_visited" >
      </div>
      <div class="form-group">
        <label>relationship</label>
        <ng-select
        [items]="relationship_list"
        bindLabel="name"
        bindValue="_id"
        [closeOnSelect]="false"
        placeholder="Select relationship"
        [(ngModel)]="selected_relationship"
        [ngModelOptions]="{ standalone: true }"
        (change)="getRelationshipId($event)"
        >
        </ng-select>
      </div>
      <div class="form-group">
        <label>Notes</label>
        <textarea class="form-control" [(ngModel)]="model.notes" name="notes" id="notes" cols="30" rows="4" placeholder="Enter notes"></textarea>
      </div>
      <div class="form-group">
        <label>Admin Notes</label>
        <textarea class="form-control" [(ngModel)]="model.admin_notes" name="admin_notes" id="admin_notes" cols="30" rows="4" placeholder="Enter admin notes"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
    </div>
  </ng-template>
</div>


<!-------------- Contacts list  Popup ------------------------------------------->
<div>
  <ng-template #myModalContact let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{row_name}}'s Contacts</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ngx-datatable [rows]="row_contacts" [rowHeight]="50" class="bootstrap core-bootstrap" [limit]="10"
        [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
        <ngx-datatable-column name="Name" prop="name" [width]="50">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <div class="d-flex align-items-center">
              {{row?.name}}
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Email" prop="email" [width]="30">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            {{row?.email }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Phone" prop="phone" [width]="10">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <span>{{row?.phone}}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Action" [width]="10">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <i class="ft-edit text-primary cursor-pointer" (click)="updateContact(row?._id)"></i>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      </div>
  </ng-template>
</div>


<!-------------- Events list  Popup ------------------------------------------->
<div>
  <ng-template #myModalEvent let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{row_name}}'s Events</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ngx-datatable [rows]="events_data" [rowHeight]="50" class="bootstrap core-bootstrap" [limit]="10"
        [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
        <ngx-datatable-column name="Name" prop="name" [width]="50">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <div class="d-flex align-items-center">
              {{row?.name}}
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Event Date" prop="event_date" [width]="30">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            {{row?.event_date }}
          </ng-template>
        </ngx-datatable-column>
        
        <!-- <ngx-datatable-column name="Action" [width]="10">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <i class="ft-edit text-primary cursor-pointer" (click)="updateContact(row?._id)"></i>
          </ng-template>
        </ngx-datatable-column> -->
      </ngx-datatable>
    </div>
    <!-- <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      </div> -->
  </ng-template>
</div>


<!-------------- Placements list  Popup ------------------------------------------->
<div>
  <ng-template #myModalPlacement let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{row_name}}'s Placements</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ngx-datatable [rows]="placement_data" [rowHeight]="50" class="bootstrap core-bootstrap" [limit]="10"
        [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
        <ngx-datatable-column name="Name" prop="name" [width]="50">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <div class="d-flex align-items-center">
              {{row?.user[0]?.name}}
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Email" prop="email" [width]="30">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            {{row?.user[0]?.email }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Phone" prop="phone" [width]="10">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <span>{{row?.user[0]?.phone}}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Placement Business" prop="placement_business" [width]="50">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <div class="d-flex align-items-center">
              {{row?.placement_business[0]?.name}}
            </div>
          </ng-template>
        </ngx-datatable-column>
        <!-- <ngx-datatable-column name="Action" [width]="10">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <i class="ft-edit text-primary cursor-pointer" (click)="updateContact(row?._id)"></i>
          </ng-template>
        </ngx-datatable-column> -->
      </ngx-datatable>
    </div>
    <!-- <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      </div> -->
  </ng-template>
</div>

<!---------- Update City Popup ------------------------ -->
<div>
  <ng-template #modalCityUpdate let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update City</h4>

      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>City</label>
        <ng-select [items]="city_list" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
          placeholder="Select City" [multiple]="true" [(ngModel)]="selected_city"
          [ngModelOptions]="{ standalone: true }" (change)="getCityId($event)" [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
        </ng-select>
      </div>
     
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="updateCity()">Submit</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
    </div>
  </ng-template>
</div>

<!---------- Update Training Tags Popup ------------------------ -->
<div>
  <ng-template #modalTgasUpdate let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update Training Tags</h4>

      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Tagging</label>
        <ng-select [items]="training_tags_list" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
          placeholder="Select Tag" [multiple]="true" [(ngModel)]="selected_training_tags"
          [ngModelOptions]="{ standalone: true }" (change)="getTrainingTagId($event)" [appendTo]="'body'"
          [virtualScroll]="true" [clearSearchOnAdd]="true">
        </ng-select>
      </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="updateTrainingTags()">Submit</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
    </div>
  </ng-template>
</div>